import type { RoleOption } from '../model/roles';

export default function RoleOptions({ options }: { options: RoleOption[] }) {
  return options.map((option) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  ));
}
